import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const MeetTheTeam = () => {
  useEffect(() => {
    document.title = 'Meet the Team | Diamond Club Matchmaking';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Meet the discreet team behind Diamond Club Matchmaking, dedicated to human-led, high-touch matchmaking.');
    }
  }, []);

  const teamMembers = [
    {
      name: 'Jacqueline Fae',
      role: 'Founder / The Faery Matchmaker',
      placeholder: 'team-1',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/s1kqwbid_Fae.jpg',
      imageStyle: { objectPosition: 'center 15%', transform: 'scale(1.15)' },
      bio: `Fae is a real-life faery godmother for the modern dating world.

With over a decade of experience in high-end matchmaking, Fae is the founder of Diamond Club Matchmaking and the I Deserve Love membership portal—exclusive platforms designed to help high-value men and women create aligned, lasting relationships. Blending psychology, NLP, intuition, and elite strategy, she helps clients break old patterns, embody their highest selves, and attract love that feels both soulful and sustainable.

Known for her signature sparkle, transformational glow-ups, and deeply intentional introductions, Fae has been featured in Forbes, Millennium, My Imperfect Life, and CBS for her work shaping modern relationship culture. Her upcoming book, Seduce Like a Goddess, invites women to reclaim their magnetism, sensual power, and self-worth—calling in epic love and a life they truly deserve.`,
    },
    {
      name: 'Zoie',
      role: 'Chief Operating Officer | Head of I Deserve Love & Member Match Portal',
      placeholder: 'team-2',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/vc89z7ok_Zoie.jpg',
      imageStyle: { objectPosition: 'center 25%', transform: 'scale(1.25)' },
      bio: `Zoie is the operational backbone of Diamond Club Matchmaking and the strategic lead behind the I Deserve Love membership and Member Match Portal.

With over a decade of life and professional experience in Los Angeles, Zoie brings a powerful blend of creativity, structure, and intuitive leadership to the organization. Her background in interior design and professional dance cultivated a deep understanding of flow, discipline, and transformation—skills she now applies to building seamless systems and elevated new-member experiences.

As COO, Zoie oversees day-to-day operations, internal systems, and execution across the Diamond Club ecosystem. As Head of I Deserve Love and the Member Match Portal, she shapes the member journey from onboarding through connection, ensuring clarity, integrity, and alignment at every touchpoint.`,
    },
    {
      name: 'Shara',
      role: 'Vice President',
      placeholder: 'team-3',
      image: 'https://customer-assets.emergentagent.com/job_4a089f9d-01a6-4529-ac94-ec15e169186e/artifacts/lha8fppi_IMG_5321.PNG',
      bio: `Shara plays a pivotal role in guiding individuals through the matchmaking journey, setting the tone for a highly curated, VIP experience rooted in trust, clarity, and excitement. With deep mastery of the company's mission, services, and proven success, she clearly articulates each membership option, ensuring clients understand the value, structure, and personalization behind every offering.

She guides clients through the full process, from philosophy and methodology to membership tiers, white-glove benefits, and expectations. Shara empowers them to confidently choose the service best aligned with their goals, lifestyle, and vision for partnership. Known for her warm, personable demeanor and New York–bred, go-getter attitude, she builds immediate credibility and connection.

Shara is committed to ensuring every client feels seen, valued, and supported from the first conversation, delivering an onboarding experience that inspires confidence throughout.`,
    },
    {
      name: 'Nina',
      role: 'Chief Relationship Officer | Matchmaker',
      placeholder: 'team-4',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/mne1jdib_Nina.jpg',
      bio: `She is deeply empathetic, intuitive, and naturally gifted in communication. Connecting with people comes effortlessly to her—not just through conversation, but through truly listening and understanding what lies beneath the surface. She has a rare ability to make others feel comfortable, seen, and genuinely heard.

Her strength lies in meaningful dialogue. She knows how to ask the right questions, hold space, and create conversations that flow with ease and intention. With a natural gift for communication and a refined sense of emotional intelligence, she helps people open up, express themselves, and connect authentically.`,
    },
    {
      name: 'Kate',
      role: 'Client Sales & Acquisition | Matchmaker',
      placeholder: 'team-5',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/zcutssba_Kate.jpeg',
      bio: `Kate is a Client Sales & Acquisition Matchmaker at Diamond Club with over seven years of experience creating thoughtfully curated connections for elite clients. With a Bachelor's degree in Accounting & Business from the University at Albany and over a decade in high-level sales, she blends strategic insight with intuition, emotional intelligence, and a natural gift for connection.

Known for her graceful, personalized approach, Kate takes the time to truly understand each client's values and desires, guiding them toward meaningful, lasting relationships. Her warmth, discretion, and attention to detail have made her a trusted presence in the luxury matchmaking space.`,
    },
    {
      name: 'Bre',
      role: 'Matchmaker',
      placeholder: 'team-6',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/bbwx3r66_Bre.jpg',
      bio: `Easy-going and fun-loving by nature, I balance a strong work ethic with a genuine love for people. I've built my career as both a private chef and a matchmaker. Two passions that let me connect, create, and bring joy into others' lives. Originally from Michigan and now based in California, I'm grounded in Midwest values with a West Coast energy. Whether I'm cooking for clients or helping someone find their perfect match, I always bring warmth, dedication, and heart to everything I do.`,
    },
    {
      name: 'Regina',
      role: 'Matchmaker',
      placeholder: 'team-7',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/ckrea04p_Regina.jpg',
      bio: `Regina is a natural connector with a deeply intuitive gift for understanding people and their hearts. She brings clarity, guidance, and grounded emotional insight to the dating process—helping clients navigate love with confidence and intention.

Blending intuition with practical strategy, Regina supports clients in presenting their best selves while attracting relationships rooted in authenticity and alignment. Her approach is heartfelt, discerning, and centered on helping clients meet the right partner—not just anyone.`,
    },
    {
      name: 'Ramon',
      role: 'Head of Digital Systems',
      placeholder: 'team-8',
      image: 'https://customer-assets.emergentagent.com/job_4a089f9d-01a6-4529-ac94-ec15e169186e/artifacts/2ffp1o1o_36990f8b-8e20-4c60-86de-3018d93269a3.PNG',
      bio: `Oversees the company's digital infrastructure, product execution, and automation systems.

Ramon leads the technical and operational backbone behind Diamond Club's digital ecosystem, ensuring that every client-facing experience—from onboarding and member portals to secure checkout—runs smoothly, reliably, and at scale. Working at the intersection of strategy and execution, he translates high-touch matchmaking services into seamless digital workflows without sacrificing discretion, personalization, or elegance.

With hands-on experience in automation, AI-enabled tooling, and modern web infrastructure, Ramon builds and maintains the systems that support Diamond Club's premium offerings and internal operations. His role bridges vision and implementation—turning ideas into functioning platforms while keeping technology aligned with the company's standards of excellence.

As a fractional operator within the organization, Ramon focuses on resilience, scalability, and clarity—so the team can stay focused on delivering exceptional, intentional connections for high-level clients.`,
    },
  ];

  return (
    <Layout>
      <section className="min-h-screen bg-black-deep grain-overlay">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          {/* Page Title */}
          <div className="text-center mb-16">
            <h1 className="font-serif text-display-sm md:text-display text-cream tracking-widest uppercase mb-6">
              Meet The Team
            </h1>
            <p className="font-sans text-cream-muted text-base max-w-2xl mx-auto">
              A discreet team dedicated to high-touch, human-led matchmaking.
            </p>
          </div>
          
          {/* Team Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member) => (
              <div 
                key={member.name}
                className="group"
              >
                {/* Photo */}
                <div 
                  className="aspect-[3/4] mb-6 overflow-hidden rounded-sm relative"
                  data-placeholder={member.placeholder}
                >
                  {member.image ? (
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-full h-full object-cover"
                      style={member.imageStyle || { objectPosition: 'center' }}
                    />
                  ) : (
                    <div className="w-full h-full placeholder-image"></div>
                  )}
                  {/* Gradient overlay on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black-deep/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                {/* Name */}
                <h3 className="font-serif text-xl text-cream mb-2 group-hover:text-gold transition-colors duration-300">
                  {member.name}
                </h3>
                
                {/* Role */}
                <p className="font-sans text-cream-muted text-sm leading-relaxed">
                  {member.role}
                </p>
                
                {/* Bio */}
                {member.bio && (
                  <p className="font-sans text-cream-muted text-sm leading-relaxed mt-4 whitespace-pre-line">
                    {member.bio}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default MeetTheTeam;
